import { ResolveFn } from '@angular/router';
import {inject} from '@angular/core';
import {EventService} from '../event.service';
import {RenderStrategy} from '../../enums/render-strategy';
import {Subscription} from 'rxjs';

export const eventResolver: ResolveFn<Promise<void | Subscription>> = async (activatedRouteSnapshot ) => {
  const slugParam = activatedRouteSnapshot.paramMap.get('slug');
  if (!slugParam) {
    return Promise.resolve();
  }
  return await inject(EventService).resolveBySlug(slugParam, RenderStrategy.PREFER_SERVER);
};
